import { colors } from '@zet/design-system'
import CircleCloseOutlined from '@zet/design-system/svg/CircleCloseOutlined'
import GroupOutlined from '@zet/design-system/svg/GroupOutlined'
import RupeeCircleOutlined from '@zet/design-system/svg/RupeeCircleOutlined'
import TagFilled from '@zet/design-system/svg/TagFilled'
import TagOutlined from '@zet/design-system/svg/TagOutlined'
import LockOutLined from '@zet/design-system/svg/lockOutlined'
import { PayoutType } from '@zet/utils/Constants'

import CautionOutlined from '@zet/design-system/svg/CautionOutlined'
import ExpiredOutlined from '@zet/design-system/svg/ExpiredOutlined'
import { GroupFilled } from '../../assests/svg'
import { i18n } from '../../localization'
import { MAGNET, OTHER, REFERRAL, ZET_REFERRAL, ZET_SALES } from './constants'

export function handleCardIconColorText(status: string) {
  switch (status) {
    case 'pending':
      return {
        textColor: '#FE8E0B',
        icon: <CautionOutlined size={18} color={'#FE8E0B'} />,
        text: 'Pending',
        bgColor: colors.warning[10],
      }
    case 'paid':
      return {
        textColor: colors.success[150],
        icon: <RupeeCircleOutlined color={colors.success[100]} size={18} />,
        text: 'Paid',
        bgColor: colors.success[10],
      }
    case 'failed':
      return {
        textColor: colors.error[150],
        icon: <CircleCloseOutlined color={colors.error[100]} size={18} />,
        text: 'Failed',
        bgColor: colors.error[10],
      }
    case 'rejected':
      return {
        textColor: colors.grays[70],
        icon: <CircleCloseOutlined color={colors.grays[80]} size={18} />,
        text: 'Rejected',
        bgColor: colors.error[10],
      }
      case 'locked':
        return {
          textColor: colors.primary[200],
          icon: <LockOutLined color={colors.primary[200]} size={18} />,
          text: 'Locked',
          bgColor: colors.primary[10],
        }
    case 'expired':
      return {
        textColor: colors.error[150],
        icon: <ExpiredOutlined  size={15} />,
        text: 'Expired',
        bgColor: colors.error[10],
      }
    default:
      return {
        textColor: colors.success[150],
        icon: <RupeeCircleOutlined color={colors.success[100]} size={18} />,
        text: 'Paid',
        bgColor: colors.success[10],
      }
  }
}
export function zetSaleCompletionText(status: string) {
  if (status === 'rejected') {
    return i18n.t('rejectOn')
  }
  return i18n.t('bankApprovedOn')
}

export function zetPaymentText(status?: string, transactionDate?: string) {
  switch (status) {
    case 'paid':
      return i18n.t('paidOnDate', { date: transactionDate })
    case 'pending':
      return i18n.t('paymentOn', { date: transactionDate })
    case 'failed':
      return i18n.t('nextPayoutDateOn', { date: transactionDate })
    case 'rejected':
      return ''
    default:
      i18n.t('paidOnDate', { date: transactionDate })
  }
}

export function filterDetails(
  filterName: string,
  markAsFilterSelected: boolean
) {
  switch (filterName) {
    case 'paymentStatus':
      return {
        label: i18n.t('status'),
        primaryIcon: markAsFilterSelected ? (
          <TagFilled size={18} />
        ) : (
          <TagOutlined size={18} />
        ),
      }

    case 'brands':
      return {
        label: i18n.t('brand'),
        primaryIcon: markAsFilterSelected ? (
          <GroupFilled size={18} />
        ) : (
          <GroupOutlined size={18} />
        ),
      }
  }
}

export function handleText(
  item: any,
  screenName: string,
  status: string,
  loyaltyUnlockingTier: string
) {
  switch (screenName) {
    case 'ZET_SALES':
      return {
        text: i18n.t(
          `${screenName}.${
            item?.transactionType === PayoutType.DEMO ? PayoutType.DEMO : status
          }`,
          {
            amount: parseFloat(item?.amount.toFixed(2)),
            reason: item?.reason || i18n.t('defaultFailedReason'),
            description: item?.description || i18n.t('defaultFailedReason'),
            tier: loyaltyUnlockingTier,
          }
        ),
        subText: '',
      }
    case 'OTHER':
      return {
        text: i18n.t('otherTransaction', { amount: item?.amount }),
        subText: item?.saleCompletedOn,
      }
    case 'REFERRAL':
      return {
        text: i18n.t(
          `${screenName}.${item?.referralTransactionType}.${status}.text`,
          {
            amount: parseFloat(item?.amount.toFixed(2)),
            reason: item?.reason || i18n.t('defaultFailedReason'),
            description: item?.description || i18n.t('defaultFailedReason'),
            tier: loyaltyUnlockingTier,
            transactionDate: item?.transactionDate,
          }
        ),
        subText: i18n.t(
          `${screenName}.${item?.referralTransactionType}.${status}.subText`,
          {
            amount: parseFloat(item?.amount.toFixed(2)),
            reason: item?.reason || i18n.t('defaultFailedReason'),
            description:
              item?.description ||
              item?.reason ||
              i18n.t('defaultFailedReason'),
            tier: loyaltyUnlockingTier,
            transactionDate: item?.transactionDate,
          }
        ),
      }
    case 'MAGNET':
      return {
        text: i18n.t(
          `${screenName}.${item?.magnetTransactionType}.${status}.text`,
          {
            amount: parseFloat(item?.amount.toFixed(2)),
            reason: item?.reason || i18n.t('defaultFailedReason'),
            description:
              item?.description ||
              item?.reason ||
              i18n.t('defaultFailedReason'),
            tier: loyaltyUnlockingTier,
            transactionDate: item?.transactionDate,
            transactionMonth: item?.transactionMonth,
          }
        ),
        subText: i18n.t(
          `${screenName}.${item?.magnetTransactionType}.${status}.subText`,
          {
            amount: parseFloat(item?.amount.toFixed(2)),
            reason: item?.reason || i18n.t('defaultFailedReason'),
            description:
              item?.description ||
              item?.reason ||
              i18n.t('defaultFailedReason'),
            tier: loyaltyUnlockingTier,
            transactionDate: item?.transactionDate,
            transactionMonth: item?.transactionMonth,
          }
        ),
      }
    default:
      return {
        text: i18n.t(`${screenName}.${status}`, {
          amount: parseFloat(item?.amount.toFixed(2)),
          reason: item?.reason || i18n.t('defaultFailedReason'),
          description: item?.description || i18n.t('defaultFailedReason'),
          tier: loyaltyUnlockingTier,
        }),
        subText: '',
      }
  }
}

export function handleSubText(
  screenName: string,
  description: string,
  partnerName: string
) {
  switch (screenName) {
    case ZET_SALES:
      return partnerName
    case REFERRAL:
      return description ? description : i18n.t('networkEarnings')
    case MAGNET:
      return ''
    case OTHER:
      return description
    case ZET_REFERRAL:
      return partnerName
  }
}
